import React, { useEffect, useState } from "react";
import { cmsContentDetailApi } from "services/cms-content";
import SuperTag from "utils/SuperTag";

const TermCondition = () => {
  const [contentValue, setContentValue] = useState("");

  // Content Detail
  const getContentDetail = async (contentType) => {
    try {
      const responseData = await cmsContentDetailApi({
        type: contentType,
        userRole: "researcher",
      });
      const {
        data: { cms = {} },
        status,
      } = responseData;
      if (status === 200) {
        setContentValue(cms || "");
      }
    } catch (e) {
      console.log("Error:", e.message);
    }
  };

  useEffect(() => {
    getContentDetail("terms");
  }, []);

  return (
    <div className="cmsPages">
      <div className="container">
       
        <div className="cms_content">
        <div className="page_title">
          <h3>Terms & Condition</h3>
        </div>
          <SuperTag>{contentValue?.description}</SuperTag>
        </div>
      </div>
    </div>
  );
};

export default TermCondition;
